import httpClient from "./httpClient";

const entityEndpoint = "/guides";

export default {
  async getAll() {
    const response = await httpClient.get(entityEndpoint);
    return response.data;
  },

  async delete(id) {
    const response = await httpClient.delete(`${entityEndpoint}/${id}`);
    return response.data;
  },

  async create(guide) {
    const response = await httpClient.post(entityEndpoint, {
      ...guide
    });
    return response.data;
  },

  async update(guide) {
    const response = await httpClient.put(`${entityEndpoint}/${guide.id}`, {
      ...guide
    });
    return response.data;
  }
};
